import React, { useState } from 'react'
import { PageHeader } from 'CommonComponent';
import { Image } from 'react-bootstrap';
import './UserManageObject.css'
import ObjectList from './List/ObjectList';
import AccessRights from 'utils/AccessRights';
import { useSelector } from "react-redux";
import ObjectAdd from './add/ObjectAdd';

const UserManageObject = () => {
  const session = useSelector(state => state.session);
  const [showAddModal, setShowAddModal] = useState(false);

  return (
    <>
      <div>
        <PageHeader title="Objects">
          {AccessRights(session.current_page_permissions, 'add') && (
            <button
              type="button"
              className='add-new-btn'
              onClick={() => setShowAddModal(true)}
            >
              <Image src='/assets/images/add-icon.svg' className='me-2 add-user-icon' alt="" aria-hidden="true" />
              Add New
            </button>
          )}
        </PageHeader>
        {/* component */}
        <ObjectList />
        <ObjectAdd
          show={showAddModal}
          onHide={() => setShowAddModal(false)}
        />
      </div>
    </>
  )
}

export default UserManageObject